module.exports = __webpack_public_path__ + "img/bq.e53fc83f.svg";